var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['check-list-flags__flag is-opl', _vm.response['payment-status']]},[_vm._v("\n  ОПЛ\n")])}
var staticRenderFns = []

export { render, staticRenderFns }